/* eslint-disable @typescript-eslint/naming-convention */

import { gql } from "@apollo/client";

export const person_entity_client_projection = gql`
  fragment person_entity_client_projection on person_entities {
    name
    description
    twitter_handle
    person_entity_pictures {
      cloudinary_public_id
    }
  }
`;

export const clip_client_projectable_data = gql`
  ${person_entity_client_projection}
  fragment clip_client_projectable_data on podcast_clips {
    id
    description
    start_time
    end_time
    duration
    podcast_episode {
      audio_url
      podcast_channel {
        title
        image_cloudinary_id
      }
      non_host_person_entities: person_entity_episodes(
        where: { is_host: { _eq: false } }
      ) {
        person_entity {
          ...person_entity_client_projection
        }
      }
      host_person_entities: person_entity_episodes(
        where: { is_host: { _eq: true } }
      ) {
        person_entity {
          ...person_entity_client_projection
        }
      }
    }
    podcast_clip_pictures {
      cloudinary_public_id
    }
  }
`;
